export const SCHEDULE_PUBLICATION_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSAbzkjUE6Ky-5ZjHQBZXyxeJLSusfZQ8jDvqR6hhF8QfUletwJmoSyqE-QhMUuFG6t5j1r0M3bRrMG/pubhtml';
export const SCHEDULE_TIME_ZONE = 'America/Vancouver';
export const SCHEDULE_REFRESH_MS = 24 * 60 * 60 * 1000;
